export enum DesignStyle {
    SITE_THEME = 'site-theme',
    BASIC = 'basic',
}

export interface FeatureMetadata {
    isNativeBookingAvailable: boolean;
    isNativeBookingPublishingAvailable: boolean;
    isPaidNativeBookingAvailable: boolean;
}

export interface BookerContextType extends FeatureMetadata {
    eventSlug: string;
    teamId: number;
    userName: string;
    rescheduleUid?: string | null;
    cancelBookingId?: string | null;
    widgetId: string;
    designStyle: DesignStyle;
    language: string;
    apiUrl: string;
    clientId: string;
    organizationId: number;
}

export interface Booking {
    title: string;
    userPrimaryEmail: string;
    startTime: string;
    user: {
        name: string;
    };
    videoCallUrl?: string;
    location?: string;
    uid: string;
    endTime: Date;
    attendees: Array<{
        name: string;
        email: string;
    }>;
    status: BookingStatus;
}

export enum UrlAction {
    RESCHEDULE = 'reschedule',
    CANCEL = 'cancel',
}

export enum BookingStatus {
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING',
    RESCHEDULED = 'RESCHEDULED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
}

export interface CalOrganization {
    id: string;
    name: string;
    slug: string;
    bannerUrl: string;
}

export interface CalUserProfile {
    id: string;
    upId: string;
    username: string;
    organizationId: string;
    organization: CalOrganization;
}

export interface CalUser {
    username: string;
    name: string;
    avatarUrl: string;
    weekStart: string;
    organizationId: string;
    bookerUrl: string;
}

export interface CalUserWithProfile extends CalUser {
    profile: CalUserProfile;
}

export interface CalHost {
    user: {
        username: string;
    };
}

export interface CalEntity {
    fromRedirectOfNonOrgLink: boolean;
    considerUnpublished: boolean;
    orgSlug: string;
    teamSlug: string;
    name: string;
    hideProfileLink: boolean;
    logoUrl: string;
}

export interface CalBookerLayouts {
    id: string;
    name: string;
    description: string;
    createdAt: string;
    updatedAt: string;
}

export interface CalParent {
    slug: string;
    name: string;
    bannerUrl: string;
    logoUrl: string;
}

export interface CalSchedule {
    id: string;
    name: string;
    description: string;
    createdAt: string;
    updatedAt: string;
}

export interface CalEventData {
    subsetOfHosts: CalHost[];
    subsetOfUsers: CalUserWithProfile[];
    entity: CalEntity;
    isDynamic: boolean;
    showInstantEventConnectNowModal: boolean;
    profile: CalUser;
    bookerLayouts: CalBookerLayouts;
    parent: CalParent;
    schedule: CalSchedule;
    instantMeetingSchedule: CalSchedule;
    periodType: string;
    periodDays: string;
    periodEndDate: string;
    periodStartDate: string;
    periodCountCalendarDays: string;
    hidden: boolean;
    assignAllTeamMembers: boolean;
    rescheduleWithSameRoundRobinHost: boolean;
}
